// Lecture d'un QR code avec l'appareil photo (téléphone) : utilisé au poste de garde pour scanner le BL.
// L'appareil photo n'est accessible que sur une adresse sécurisée (https) ; sinon, saisie du numéro à la main.
import React, { useEffect, useRef, useState } from 'react';
import { Alert, Box, Button, Typography } from '@mui/material';
import jsQR from 'jsqr';

const ScannerQR = ({ onResultat, onFermer }) => {
  const video = useRef(); const canvas = useRef();
  const [erreur, setErreur] = useState('');
  useEffect(() => {
    let flux = null; let minuteur = null; let fini = false;
    const arreter = () => { fini = true; clearInterval(minuteur); if (flux) flux.getTracks().forEach((t) => t.stop()); };
    (async () => {
      if (!navigator.mediaDevices?.getUserMedia) { setErreur(window.isSecureContext ? "Cet appareil ne permet pas d'utiliser l'appareil photo ici." : "L'appareil photo n'est disponible que sur l'adresse sécurisée (https) de l'application. Tapez le numéro du BL."); return; }
      try {
        flux = await navigator.mediaDevices.getUserMedia({ video: { facingMode: { ideal: 'environment' } }, audio: false });
        if (fini) { flux.getTracks().forEach((t) => t.stop()); return; }
        video.current.srcObject = flux; video.current.setAttribute('playsinline', 'true'); await video.current.play();
        minuteur = setInterval(() => {
          const v = video.current; const c = canvas.current;
          if (!v || !c || v.readyState < 2) return;
          const w = v.videoWidth; const h = v.videoHeight; if (!w || !h) return;
          const k = Math.min(1, 720 / Math.max(w, h)); c.width = Math.round(w * k); c.height = Math.round(h * k);
          const ctx = c.getContext('2d', { willReadFrequently: true }); ctx.drawImage(v, 0, 0, c.width, c.height);
          const img = ctx.getImageData(0, 0, c.width, c.height);
          const code = jsQR(img.data, img.width, img.height, { inversionAttempts: 'dontInvert' });
          if (code?.data) { arreter(); if (navigator.vibrate) navigator.vibrate(120); onResultat(code.data); }
        }, 250);
      } catch (e) {
        setErreur(e?.name === 'NotAllowedError' ? "Accès à l'appareil photo refusé : autorisez-le dans le navigateur, ou tapez le numéro du BL." : "Appareil photo indisponible : tapez le numéro du BL.");
      }
    })();
    return arreter;
  }, [onResultat]);
  return (
    <Box>
      {erreur ? <Alert severity="warning" sx={{ mb: 1 }}>{erreur}</Alert> : (
        <Box sx={{ position: 'relative', borderRadius: 2, overflow: 'hidden', bgcolor: '#000', aspectRatio: '1 / 1', maxHeight: 360, mx: 'auto' }}>
          <video ref={video} muted style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          <Box sx={{ position: 'absolute', inset: '18%', border: '3px solid rgba(255,255,255,.85)', borderRadius: 2 }} />
          <Typography sx={{ position: 'absolute', bottom: 8, left: 0, right: 0, textAlign: 'center', color: '#fff', fontSize: 13 }}>Visez le QR code du BL</Typography>
        </Box>
      )}
      <canvas ref={canvas} style={{ display: 'none' }} />
      {onFermer && <Button fullWidth sx={{ mt: 1 }} onClick={onFermer}>Taper le numéro à la place</Button>}
    </Box>
  );
};

export default ScannerQR;
